import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'MobileNav',
})(
  (
    { brandColors, type, breakpoints, zLevels, spacing, typography },
    props
  ) => ({
    navBodyMobileSelectedItem: {
      borderBottom: `4px solid ${brandColors.primaryMain}`,
      zIndex: zLevels.fixed,
    },
    selectedItemDark: {
      borderBottomColor: brandColors.white,
    },
    bannerHidden: {
      height: 0,
      overflow: 'hidden',
      transition: 'height .25s',
    },
    mobileNavItemWrapper: {
      '&:first-of-type': {
        paddingTop: spacing(2),
      },
    },
    logo: {
      margin: `${typography.pxToRem(16)} ${typography.pxToRem(3)}`,
    },
    mobileNavItem: {
      cursor: 'pointer',
      padding: `${typography.pxToRem(12)} ${spacing(3)} ${typography.pxToRem(
        12
      )} ${spacing(3)}`,
      flexDirection: 'row',
      alignItems: 'center',

      position: 'relative',
      justifyContent: 'space-between',
      display: 'flex',
      width: '100vw',
      ...type['20_medium'],
      height: typography.pxToRem(56),
      [breakpoints.up('lg')]: {
        padding: `${typography.pxToRem(12)} ${spacing(3)} ${typography.pxToRem(
          12
        )} ${spacing(3)}`,
      },
    },
    buttonWrapper: {
      height: typography.pxToRem(44),
      minWidth: typography.pxToRem(116),
      float: 'right',
      [breakpoints.up('md')]: {
        height: 'inherit',
      },
      '& div': {
        height: '100%',
        '& a': {
          height: '100%',
          textDecoration: 'none',
        },
      },
    },
    mobileNavDropdown: {
      zIndex: zLevels.dropdown,
      position: 'fixed',
      display: 'flex',
      flexDirection: 'row',
      top: typography.pxToRem(60),
      bottom: 0,
      left: 0,
      right: '-100%',
      background: 'rgba(255, 252, 245, 1)',
      transform: 'translateX(0%)',
      transition: 'transform .25s',
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      scrollbarWidth: 'none',
    },
    mobileNavDropdownDark: {
      background: brandColors.tintsHeroBlue10,
    },
    mobileNavLeftSide: {
      width: '50%',
      transition: 'width .25s',
      paddingTop: spacing(1),
      marginTop: spacing(1),
    },
    mobileNavRightSide: {
      width: '50%',
      background: brandColors.tintsOffWhite60,
      zIndex: zLevels.popover,
      position: 'relative',
    },
    mobileNavLinksView: {
      width: '0%',
      transition: 'width .25s',
      overflow: 'hidden',
      paddingBottom: typography.pxToRem(16),
    },
    mobileDropdownInfo: {
      padding: ` ${spacing(2)} ${spacing(3)} ${spacing(3)} ${spacing(3)}`,
      [breakpoints.up('md')]: {
        display: 'none',
      },
      '& > div': {
        borderTop: '1px solid var(--line, rgba(0, 0, 0, 0.20))',
        paddingTop: typography.pxToRem(16),
      },
    },
    utilityLink: {
      ...type['14_medium'],
      color: brandColors.mediumBlue,
      padding: `${typography.pxToRem(12)} ${typography.pxToRem(0)}`,
      display: 'flex',
      flexDirection: 'row',
      gap: typography.pxToRem(6),
      textDecoration: 'none',
    },
    utilityLinkDark: {
      color: brandColors.tintsChargeBlue60,
    },
    hamburgerIconContainer: {
      padding: `${typography.pxToRem(8.25)} ${typography.pxToRem(10)}`,
      color: brandColors.primaryMain,
      marginRight: typography.pxToRem(12),
    },
    t1ParentPageLabelContainer: {
      flex: 1,
      justifyContent: 'center',
      display: 'flex',
      '& h3': { ...type['18_medium'] },
    },
    locationDisplay: {
      color: darkOrLightStyle(props)(
        brandColors.tintsChargeBlue60,
        brandColors.mediumBlue
      ),
    },
  })
);

export default useStyles;
